<div class="infoportal-container">
  <div class="infoportal-nav">
    <app-infoportal-api-navigation></app-infoportal-api-navigation>
  </div>
  <div class="infoportal-content">
    <div class="infoportal-content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
